// BM-H3532 (4 Oct 2026, Vanessa): "A deferred conflict should carry a banner,
// it's deferred because a property seller may have no buyer at the time they
// open their file." A deferral lets the matter proceed through the golden
// rule chain, so the matter page says so on every visit until the search is
// run. An open deferral still blocks exchange (BM-H613).
import { useNavigate } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { Button } from "./ui/button";

function formatDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
}

export default function DeferredConflictBanner({ deferred }) {
  const navigate = useNavigate();
  if (!deferred) return null;
  const since = formatDate(deferred.deferred_at);
  return (
    <div className="mb-4 rounded-md border border-amber-500/40 bg-status-amber-dim/20 p-3 flex items-start gap-3"
         role="status" data-testid="deferred-conflict-banner">
      <ShieldAlert className="w-5 h-5 text-status-amber shrink-0 mt-0.5" />
      <div className="flex-1 text-sm text-status-amber">
        <p className="font-bold">
          Conflict check deferred{since ? ` since ${since}` : ""}
          {deferred.deferred_by ? ` by ${deferred.deferred_by}` : ""}
        </p>
        <p className="text-status-amber/90">
          {deferred.reason ? `Reason: ${deferred.reason}. ` : ""}
          The matter can carry on, but run the search as soon as the other side is known.
          Exchange stays blocked until the check is completed.
        </p>
      </div>
      {deferred.conflict_check_id && (
        <Button size="sm" variant="outline" data-testid="deferred-conflict-complete-btn"
                onClick={() => navigate(`/conflict-search?complete_deferred=${encodeURIComponent(deferred.conflict_check_id)}`)}>
          Complete check
        </Button>
      )}
    </div>
  );
}
